// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --w-primary: #6A9E2C;
  --w-primary-hover: #8CC63E;
  --w-primary-dark: #4d7320;
  --w-bg: #f5f7f4;
  --w-bg-alt: #ffffff;
  --w-text: #2c2c2c;
  --w-text-soft: #5b5b5b;
  --w-text-mute: #8a8a8a;
  --w-border: rgba(0, 0, 0, 0.08);
  --w-shadow-sm: 0 4px 12px rgba(0, 0, 0, 0.06);
  --w-shadow-md: 0 10px 28px rgba(0, 0, 0, 0.10);
  --w-shadow-lg: 0 20px 50px rgba(0, 0, 0, 0.18);
}

/* ===== Root ===== */
.welcome-root {
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(180deg, #f7faf3 0%, #ffffff 30%, #f5f7f4 100%);
  color: var(--w-text);
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

/* ===== Header ===== */
.welcome-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  flex-wrap: wrap;
  width: 100%;
  padding: 14px 24px;
  background: #ffffff;
  box-shadow: 0 2px 18px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 50;
  backdrop-filter: blur(10px);
}

.welcome-header-logo-link {
  display: inline-flex;
  align-items: center;
}

.welcome-header-logo {
  height: 34px;
  width: auto;
  transition: transform 200ms ease;
}

.welcome-header-logo:hover {
  transform: scale(1.04);
}

.welcome-header-title {
  font-weight: 700 !important;
  font-size: clamp(1.05rem, 2.4vw, 1.6rem) !important;
  letter-spacing: -0.01em;
  color: var(--w-text);
  text-align: center;
}

/* ===== Hero ===== */
.welcome-hero {
  position: relative;
  padding: 56px 16px 72px;
  background:
    radial-gradient(900px 360px at 90% -10%, rgba(140, 198, 62, 0.22), transparent 60%),
    radial-gradient(700px 320px at -10% 110%, rgba(106, 158, 44, 0.18), transparent 60%);
  animation: welcomeFadeIn 0.7s ease both;
}

@keyframes welcomeFadeIn {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}

.welcome-hero-chip {
  background: rgba(106, 158, 44, 0.12) !important;
  color: var(--w-primary-dark) !important;
  font-weight: 600 !important;
  letter-spacing: 0.04em;
  margin-bottom: 16px !important;
}

.welcome-hero-title {
  font-weight: 800 !important;
  font-size: clamp(1.8rem, 4vw, 2.6rem) !important;
  line-height: 1.15 !important;
  letter-spacing: -0.02em;
  margin-bottom: 14px !important;
  background: linear-gradient(135deg, #1f1f1f 0%, var(--w-primary-dark) 90%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.welcome-hero-text {
  color: var(--w-text-soft) !important;
  font-size: 1.05rem !important;
  line-height: 1.65 !important;
  text-align: justify;
  margin-bottom: 22px !important;
}

.welcome-hero-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.welcome-cta {
  display: inline-flex;
  align-items: center;
  padding: 0.85rem 1.4rem;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  color: #fff;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: linear-gradient(135deg, var(--w-primary) 0%, var(--w-primary-hover) 100%);
  box-shadow: 0 10px 24px rgba(106, 158, 44, 0.35);
  transition: transform 200ms ease, box-shadow 200ms ease, filter 200ms ease;
}

.welcome-cta:hover {
  transform: translateY(-2px);
  filter: brightness(1.05);
  box-shadow: 0 14px 28px rgba(106, 158, 44, 0.45);
}

.welcome-cta:active {
  transform: translateY(0);
}

.welcome-hero-image-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 24px;
}

.welcome-hero-image-wrap::before {
  content: "";
  position: absolute;
  inset: 10% 14%;
  background: radial-gradient(closest-side, rgba(106, 158, 44, 0.25), transparent 70%);
  filter: blur(20px);
  z-index: 0;
}

.welcome-hero-image {
  position: relative;
  z-index: 1;
  max-height: 360px;
  max-width: 100%;
  width: auto;
  filter: drop-shadow(0 20px 30px rgba(0, 0, 0, 0.18));
  animation: floatY 6s ease-in-out infinite;
}

@keyframes floatY {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-10px); }
}

/* ===== Features ===== */
.welcome-features {
  margin-top: 40px !important;
}

.welcome-feature-card {
  padding: 22px 20px;
  background: #ffffff;
  border-radius: 18px !important;
  border: 1px solid var(--w-border);
  box-shadow: var(--w-shadow-sm) !important;
  transition: transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease;
  height: 100%;
}

.welcome-feature-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--w-shadow-md) !important;
  border-color: rgba(106, 158, 44, 0.35);
}

.welcome-feature-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(106, 158, 44, 0.12), rgba(140, 198, 62, 0.18));
  color: var(--w-primary-dark);
  margin-bottom: 14px;
}

.welcome-feature-title {
  font-weight: 700 !important;
  font-size: 1.05rem !important;
  margin-bottom: 6px !important;
}

.welcome-feature-text {
  color: var(--w-text-soft) !important;
  line-height: 1.5 !important;
}

/* ===== Scroll hint ===== */
.welcome-scroll-hint {
  margin: 36px auto 0;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--w-text-mute);
  cursor: pointer;
  animation: bounceDown 2.2s ease-in-out infinite;
  -webkit-user-select: none;
          user-select: none;
}

.welcome-scroll-hint:hover {
  color: var(--w-primary);
}

@keyframes bounceDown {
  0%, 100% { transform: translateY(0); opacity: 0.7; }
  50%      { transform: translateY(6px); opacity: 1; }
}

/* ===== Kioskos band ===== */
.welcome-kioskos-band {
  background: linear-gradient(180deg, #ffffff 0%, #eef2ea 100%);
  padding: 28px 0 16px;
  border-top: 1px solid var(--w-border);
  border-bottom: 1px solid var(--w-border);
}

.welcome-kioskos-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== Videos ===== */
.welcome-videos {
  padding: 64px 16px 80px;
  background: linear-gradient(180deg, #ffffff 0%, #f5f7f4 100%);
}

.welcome-section-head {
  text-align: center;
  max-width: 760px;
  margin: 0 auto 36px;
}

.welcome-section-chip {
  background: rgba(106, 158, 44, 0.12) !important;
  color: var(--w-primary-dark) !important;
  font-weight: 600 !important;
  letter-spacing: 0.04em;
  margin-bottom: 12px !important;
}

.welcome-section-title {
  font-weight: 800 !important;
  letter-spacing: -0.02em;
  font-size: clamp(1.5rem, 3vw, 2.1rem) !important;
  margin-bottom: 10px !important;
}

.welcome-section-subtitle {
  color: var(--w-text-soft) !important;
  font-size: 1rem !important;
  line-height: 1.55 !important;
}

/* Video card */
.welcome-video-card {
  border-radius: 18px !important;
  overflow: hidden;
  box-shadow: var(--w-shadow-sm) !important;
  transition: transform 240ms ease, box-shadow 240ms ease;
  background: #ffffff;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.welcome-video-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--w-shadow-lg) !important;
}

.welcome-video-card .MuiCardActionArea-root {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.welcome-video-thumb-wrap {
  position: relative;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-video-thumb-pattern {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.18) 0, transparent 30%),
    radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.12) 0, transparent 35%),
    repeating-linear-gradient(135deg, rgba(255, 255, 255, 0.04) 0 10px, transparent 10px 20px);
  pointer-events: none;
}

.welcome-video-thumb-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 400ms ease, opacity 400ms ease;
  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.25));
}

.welcome-video-card:hover .welcome-video-thumb-icon {
  transform: scale(1.08);
  opacity: 0.55;
}

.welcome-video-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.55) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 220ms ease;
}

.welcome-video-card:hover .welcome-video-overlay {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.6) 100%);
}

.welcome-video-play {
  font-size: 72px !important;
  color: #ffffff;
  opacity: 0.92;
  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.4));
  transition: transform 220ms ease, opacity 220ms ease;
}

.welcome-video-card:hover .welcome-video-play {
  transform: scale(1.08);
  opacity: 1;
}

.welcome-video-number {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  color: #ffffff;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
  font-size: 0.95rem;
}

.welcome-video-content {
  padding: 18px 18px 22px !important;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.welcome-video-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.welcome-video-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-video-audience {
  background: rgba(0, 0, 0, 0.06) !important;
  color: var(--w-text-soft) !important;
  font-weight: 600 !important;
  font-size: 0.72rem !important;
}

.welcome-video-title {
  font-weight: 700 !important;
  font-size: 1.05rem !important;
  line-height: 1.3 !important;
  color: var(--w-text);
}

.welcome-video-desc {
  color: var(--w-text-soft) !important;
  line-height: 1.5 !important;
  font-size: 0.9rem !important;
}

/* ===== Footer ===== */
.welcome-footer {
  background: #2c2c2c;
  color: #ffffff;
  width: 100%;
  text-align: center;
  padding: 14px 16px;
  margin-top: auto;
}

.welcome-footer .MuiTypography-root {
  color: #ffffff;
  letter-spacing: 0.04em;
  opacity: 0.9;
}

/* ===== Responsive ===== */
@media (max-width: 600px) {
  .welcome-hero { padding: 36px 12px 48px; }
  .welcome-hero-text { text-align: left; }
  .welcome-videos { padding: 48px 12px 64px; }
  .welcome-header { padding: 10px 14px; gap: 10px; }
  .welcome-header-logo { height: 28px; }
  .welcome-hero-image { max-height: 260px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/welcome/WelcomePage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;EAC/B,6CAA6C;EAC7C,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,WAAW;EACX,0EAA0E;EAC1E,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;EACnD,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,uBAAuB;EACvB;;wFAEsF;EACtF,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,+CAA+C;EAC/C,uCAAuC;EACvC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;EAC9B,0EAA0E;EAC1E,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,qFAAqF;EACrF,gDAAgD;EAChD,0EAA0E;AAC5E;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,oFAAoF;EACpF,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,oDAAoD;EACpD,yCAAyC;AAC3C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,WAAW,4BAA4B,EAAE;AAC3C;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,yCAAyC;EACzC,gFAAgF;EAChF,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uFAAuF;EACvF,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,+CAA+C;EAC/C,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW,wBAAwB,EAAE,YAAY,EAAE;EACnD,WAAW,0BAA0B,EAAE,UAAU,EAAE;AACrD;;AAEA,6BAA6B;AAC7B;EACE,6DAA6D;EAC7D,oBAAoB;EACpB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,uCAAuC;EACvC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,yCAAyC;EACzC,uDAAuD;EACvD,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;8FAG4F;EAC5F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;EACpD,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mFAAmF;EACnF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,kDAAkD;EAClD,oDAAoD;AACtD;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB,uBAAuB,EAAE;EACzC,qBAAqB,gBAAgB,EAAE;EACvC,kBAAkB,uBAAuB,EAAE;EAC3C,kBAAkB,kBAAkB,EAAE,SAAS,EAAE;EACjD,uBAAuB,YAAY,EAAE;EACrC,sBAAsB,iBAAiB,EAAE;AAC3C","sourcesContent":[":root {\n  --w-primary: #6A9E2C;\n  --w-primary-hover: #8CC63E;\n  --w-primary-dark: #4d7320;\n  --w-bg: #f5f7f4;\n  --w-bg-alt: #ffffff;\n  --w-text: #2c2c2c;\n  --w-text-soft: #5b5b5b;\n  --w-text-mute: #8a8a8a;\n  --w-border: rgba(0, 0, 0, 0.08);\n  --w-shadow-sm: 0 4px 12px rgba(0, 0, 0, 0.06);\n  --w-shadow-md: 0 10px 28px rgba(0, 0, 0, 0.10);\n  --w-shadow-lg: 0 20px 50px rgba(0, 0, 0, 0.18);\n}\n\n/* ===== Root ===== */\n.welcome-root {\n  min-height: 100vh;\n  width: 100%;\n  background: linear-gradient(180deg, #f7faf3 0%, #ffffff 30%, #f5f7f4 100%);\n  color: var(--w-text);\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n}\n\n/* ===== Header ===== */\n.welcome-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  flex-wrap: wrap;\n  width: 100%;\n  padding: 14px 24px;\n  background: #ffffff;\n  box-shadow: 0 2px 18px rgba(0, 0, 0, 0.08);\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  backdrop-filter: blur(10px);\n}\n\n.welcome-header-logo-link {\n  display: inline-flex;\n  align-items: center;\n}\n\n.welcome-header-logo {\n  height: 34px;\n  width: auto;\n  transition: transform 200ms ease;\n}\n\n.welcome-header-logo:hover {\n  transform: scale(1.04);\n}\n\n.welcome-header-title {\n  font-weight: 700 !important;\n  font-size: clamp(1.05rem, 2.4vw, 1.6rem) !important;\n  letter-spacing: -0.01em;\n  color: var(--w-text);\n  text-align: center;\n}\n\n/* ===== Hero ===== */\n.welcome-hero {\n  position: relative;\n  padding: 56px 16px 72px;\n  background:\n    radial-gradient(900px 360px at 90% -10%, rgba(140, 198, 62, 0.22), transparent 60%),\n    radial-gradient(700px 320px at -10% 110%, rgba(106, 158, 44, 0.18), transparent 60%);\n  animation: welcomeFadeIn 0.7s ease both;\n}\n\n@keyframes welcomeFadeIn {\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.welcome-hero-chip {\n  background: rgba(106, 158, 44, 0.12) !important;\n  color: var(--w-primary-dark) !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.04em;\n  margin-bottom: 16px !important;\n}\n\n.welcome-hero-title {\n  font-weight: 800 !important;\n  font-size: clamp(1.8rem, 4vw, 2.6rem) !important;\n  line-height: 1.15 !important;\n  letter-spacing: -0.02em;\n  margin-bottom: 14px !important;\n  background: linear-gradient(135deg, #1f1f1f 0%, var(--w-primary-dark) 90%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.welcome-hero-text {\n  color: var(--w-text-soft) !important;\n  font-size: 1.05rem !important;\n  line-height: 1.65 !important;\n  text-align: justify;\n  margin-bottom: 22px !important;\n}\n\n.welcome-hero-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.welcome-cta {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.85rem 1.4rem;\n  border-radius: 14px;\n  border: none;\n  cursor: pointer;\n  color: #fff;\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  background: linear-gradient(135deg, var(--w-primary) 0%, var(--w-primary-hover) 100%);\n  box-shadow: 0 10px 24px rgba(106, 158, 44, 0.35);\n  transition: transform 200ms ease, box-shadow 200ms ease, filter 200ms ease;\n}\n\n.welcome-cta:hover {\n  transform: translateY(-2px);\n  filter: brightness(1.05);\n  box-shadow: 0 14px 28px rgba(106, 158, 44, 0.45);\n}\n\n.welcome-cta:active {\n  transform: translateY(0);\n}\n\n.welcome-hero-image-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 24px;\n}\n\n.welcome-hero-image-wrap::before {\n  content: \"\";\n  position: absolute;\n  inset: 10% 14%;\n  background: radial-gradient(closest-side, rgba(106, 158, 44, 0.25), transparent 70%);\n  filter: blur(20px);\n  z-index: 0;\n}\n\n.welcome-hero-image {\n  position: relative;\n  z-index: 1;\n  max-height: 360px;\n  max-width: 100%;\n  width: auto;\n  filter: drop-shadow(0 20px 30px rgba(0, 0, 0, 0.18));\n  animation: floatY 6s ease-in-out infinite;\n}\n\n@keyframes floatY {\n  0%, 100% { transform: translateY(0); }\n  50%      { transform: translateY(-10px); }\n}\n\n/* ===== Features ===== */\n.welcome-features {\n  margin-top: 40px !important;\n}\n\n.welcome-feature-card {\n  padding: 22px 20px;\n  background: #ffffff;\n  border-radius: 18px !important;\n  border: 1px solid var(--w-border);\n  box-shadow: var(--w-shadow-sm) !important;\n  transition: transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease;\n  height: 100%;\n}\n\n.welcome-feature-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--w-shadow-md) !important;\n  border-color: rgba(106, 158, 44, 0.35);\n}\n\n.welcome-feature-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, rgba(106, 158, 44, 0.12), rgba(140, 198, 62, 0.18));\n  color: var(--w-primary-dark);\n  margin-bottom: 14px;\n}\n\n.welcome-feature-title {\n  font-weight: 700 !important;\n  font-size: 1.05rem !important;\n  margin-bottom: 6px !important;\n}\n\n.welcome-feature-text {\n  color: var(--w-text-soft) !important;\n  line-height: 1.5 !important;\n}\n\n/* ===== Scroll hint ===== */\n.welcome-scroll-hint {\n  margin: 36px auto 0;\n  width: fit-content;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: var(--w-text-mute);\n  cursor: pointer;\n  animation: bounceDown 2.2s ease-in-out infinite;\n  user-select: none;\n}\n\n.welcome-scroll-hint:hover {\n  color: var(--w-primary);\n}\n\n@keyframes bounceDown {\n  0%, 100% { transform: translateY(0); opacity: 0.7; }\n  50%      { transform: translateY(6px); opacity: 1; }\n}\n\n/* ===== Kioskos band ===== */\n.welcome-kioskos-band {\n  background: linear-gradient(180deg, #ffffff 0%, #eef2ea 100%);\n  padding: 28px 0 16px;\n  border-top: 1px solid var(--w-border);\n  border-bottom: 1px solid var(--w-border);\n}\n\n.welcome-kioskos-img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* ===== Videos ===== */\n.welcome-videos {\n  padding: 64px 16px 80px;\n  background: linear-gradient(180deg, #ffffff 0%, #f5f7f4 100%);\n}\n\n.welcome-section-head {\n  text-align: center;\n  max-width: 760px;\n  margin: 0 auto 36px;\n}\n\n.welcome-section-chip {\n  background: rgba(106, 158, 44, 0.12) !important;\n  color: var(--w-primary-dark) !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.04em;\n  margin-bottom: 12px !important;\n}\n\n.welcome-section-title {\n  font-weight: 800 !important;\n  letter-spacing: -0.02em;\n  font-size: clamp(1.5rem, 3vw, 2.1rem) !important;\n  margin-bottom: 10px !important;\n}\n\n.welcome-section-subtitle {\n  color: var(--w-text-soft) !important;\n  font-size: 1rem !important;\n  line-height: 1.55 !important;\n}\n\n/* Video card */\n.welcome-video-card {\n  border-radius: 18px !important;\n  overflow: hidden;\n  box-shadow: var(--w-shadow-sm) !important;\n  transition: transform 240ms ease, box-shadow 240ms ease;\n  background: #ffffff;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.welcome-video-card:hover {\n  transform: translateY(-6px);\n  box-shadow: var(--w-shadow-lg) !important;\n}\n\n.welcome-video-card .MuiCardActionArea-root {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.welcome-video-thumb-wrap {\n  position: relative;\n  overflow: hidden;\n  aspect-ratio: 16 / 9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.welcome-video-thumb-pattern {\n  position: absolute;\n  inset: 0;\n  background-image:\n    radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.18) 0, transparent 30%),\n    radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.12) 0, transparent 35%),\n    repeating-linear-gradient(135deg, rgba(255, 255, 255, 0.04) 0 10px, transparent 10px 20px);\n  pointer-events: none;\n}\n\n.welcome-video-thumb-icon {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 400ms ease, opacity 400ms ease;\n  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.25));\n}\n\n.welcome-video-card:hover .welcome-video-thumb-icon {\n  transform: scale(1.08);\n  opacity: 0.55;\n}\n\n.welcome-video-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.55) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 220ms ease;\n}\n\n.welcome-video-card:hover .welcome-video-overlay {\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.6) 100%);\n}\n\n.welcome-video-play {\n  font-size: 72px !important;\n  color: #ffffff;\n  opacity: 0.92;\n  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.4));\n  transition: transform 220ms ease, opacity 220ms ease;\n}\n\n.welcome-video-card:hover .welcome-video-play {\n  transform: scale(1.08);\n  opacity: 1;\n}\n\n.welcome-video-number {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  color: #ffffff;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);\n  font-size: 0.95rem;\n}\n\n.welcome-video-content {\n  padding: 18px 18px 22px !important;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.welcome-video-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.welcome-video-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.welcome-video-audience {\n  background: rgba(0, 0, 0, 0.06) !important;\n  color: var(--w-text-soft) !important;\n  font-weight: 600 !important;\n  font-size: 0.72rem !important;\n}\n\n.welcome-video-title {\n  font-weight: 700 !important;\n  font-size: 1.05rem !important;\n  line-height: 1.3 !important;\n  color: var(--w-text);\n}\n\n.welcome-video-desc {\n  color: var(--w-text-soft) !important;\n  line-height: 1.5 !important;\n  font-size: 0.9rem !important;\n}\n\n/* ===== Footer ===== */\n.welcome-footer {\n  background: #2c2c2c;\n  color: #ffffff;\n  width: 100%;\n  text-align: center;\n  padding: 14px 16px;\n  margin-top: auto;\n}\n\n.welcome-footer .MuiTypography-root {\n  color: #ffffff;\n  letter-spacing: 0.04em;\n  opacity: 0.9;\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 600px) {\n  .welcome-hero { padding: 36px 12px 48px; }\n  .welcome-hero-text { text-align: left; }\n  .welcome-videos { padding: 48px 12px 64px; }\n  .welcome-header { padding: 10px 14px; gap: 10px; }\n  .welcome-header-logo { height: 28px; }\n  .welcome-hero-image { max-height: 260px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
